(function () {
    'use strict';

    angular
        .module('procedureControllers')
        .controller('ProcedureEditAccessRightsController', Controller);

    Controller.$inject = ['$scope', '$state', '$window', 'procedureService', 'modalService', 'notificationService', 'procedure'];

    function Controller($scope, $state, $window, procedureService, modalService, notificationService, procedure) {

        $scope.procedure = procedure;

        $scope.ctxtCtrl = {
            isLoading: false,
            isDirty: false
        };

        // Add Owner
        $scope.addOwner = function (person) {
            $scope.ctxtCtrl.isDirty = true;
            $scope.procedure.Owners.push(person);
        };

        // Remove Owner
        $scope.removeOwner = function (person)
        {
            $scope.ctxtCtrl.isDirty = true;
            _.remove($scope.procedure.Owners, {ItemPersonID: person.ItemPersonID});
        };

        // Add Reader
        $scope.addReader = function (person) {
            $scope.ctxtCtrl.isDirty = true;
            $scope.procedure.Readers.push(person);
        };

        // Remove Reader
        $scope.removeReader = function (person)
        {
            $scope.ctxtCtrl.isDirty = true;
            _.remove($scope.procedure.Readers, {ItemPersonID: person.ItemPersonID});
        };

        // Cancel
        $scope.cancel = function () {
            $window.history.back();
        };

        // Save
        $scope.save = function () {
            if (!$scope.ctxtCtrl.isDirty) return;

            $scope.ctxtCtrl.isLoading = true;

            procedureService
                .updateReferenceDocumentWithOwnersAndReaders($scope.procedure)
                .then(function () {
                    notificationService.notify('Access Rights Updated Successfully');
                    $state.go('^');
                })
                .finally(function () {
                    $scope.ctxtCtrl.isLoading = false;
                });
        };
    }
})();